"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.invalidPersonalInfo_isEmail = exports.invalidPersonalInfo_isOfLength = exports.invalidPersonalInfo_isOfAgeOrYounger = exports.invalidPersonalInfo_isOfAgeOrOlder = exports.invalidPersonalInfo_isDate = exports.invalidPersonalInfo_isOfType = exports.invalidPersonalInfo_isShorterOrEq = exports.invalidPersonalInfo_isAlpha = exports.invalidPersonalInfo_isNotEmpty = exports.validPersonalInfo = void 0;
exports.validPersonalInfo = {
    firstName: 'Test',
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/1990',
    phone: '2127073344',
};
exports.invalidPersonalInfo_isNotEmpty = {
    firstName: '', // isNotEmpty
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/1990',
    phone: '2127073344',
};
exports.invalidPersonalInfo_isAlpha = {
    firstName: 'XÆA-12', // isAlpha
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/1990',
    phone: '2127073344',
};
exports.invalidPersonalInfo_isShorterOrEq = {
    firstName: 'TestTestTestTestTestTestTestTes', // isShorterOrEq
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/1990',
    phone: '2127073344',
};
exports.invalidPersonalInfo_isOfType = {
    firstName: 12, // isOfType
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/1990',
    phone: '2127073344',
};
exports.invalidPersonalInfo_isDate = {
    firstName: 'Test',
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/YOLO', // isDate
    phone: '2127073344',
};
exports.invalidPersonalInfo_isOfAgeOrOlder = {
    firstName: 'Test',
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/2010', // isOfAgeOrOlder
    phone: '2127073344',
};
exports.invalidPersonalInfo_isOfAgeOrYounger = {
    firstName: 'Test',
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/1854', // isOfAgeOrYounger
    phone: '2127073344',
};
exports.invalidPersonalInfo_isOfLength = {
    firstName: 'Test',
    lastName: 'Test',
    email: 'test@gmail.com',
    dateOfBirth: '01/01/185', // isOfLength
    phone: '2127073344',
};
exports.invalidPersonalInfo_isEmail = {
    firstName: 'Test',
    lastName: 'Test',
    email: 'test@gmail', // isEmail
    dateOfBirth: '01/01/185',
    phone: '2127073344',
};
